<label [class.disabled]="disabled || !available" [class.checked]="check">
    <input type="checkbox" [(ngModel)]="check" [disabled]="disabled" (change)="change()">
    <img *ngIf="avatar" [src]="avatar|absolutePath:'ingredients'" border="0" height="20px">
    <div class="bullet-icon">
        <i class="flaticon-exclamation" *ngIf="!available"></i>
        <img class="img-UnCheck" src="assets/images/UnCheck.png" *ngIf="available" width="20px" alt="" srcset="">
        <img class="img-tick" src="assets/images/check.png" *ngIf="available" width="20px" alt="" srcset="">
    </div>
    <span class="label"> {{label}} </span>
</label>